/*       */

import { gql } from '@apollo/client';

export default gql`
    query locationGetCoordinatesQuery($address: String!) {
        result: getCoordinates(address: $address)
    }
`;
